import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Head from 'next/head';

import getMetaTagData from '../../../../src/common/services/getMetaTagData';
// import adGenerater from '../../../src/common/services/adGenerater';
import TvTopMenu from '../../../../src/component/m/tv/TopMenu';

function Home({ testData, metaTagData }) {
  const router = useRouter();
  return (
    <div className="contents">
      <Head>
        <link
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_M_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          name="viewport"
          content="user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width"
        />
        <script
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>
      <div role="main" id="container" className="tv_listcontents_wrap">
        {/* 페이지 명 클래스  */}
        <TvTopMenu
          sectionCode={router.query.pageSection}
          categoryCode={router.query.pageCategory}
        />
      </div>
    </div>
  );
}

export async function getServerSideProps(ctx) {
  const res = await fetch(process.env.API_TEST);
  const { home: testData } =
    res.status === 200 ? await res.json() : { home: {} };

  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { testData, metaTagData } };
}

export default Home;
